<div>
    <input class="admin-ping-btn" type="button" name="ping" value="{{'PING'|translate}}"
        (click)="getApiCallForPing()">&nbsp;
    <img *ngIf="isShowSpinner && !isShowGreen" src="assets/images/ajax-loader.gif" width="30" height="30">
    <img *ngIf="isShowGreen && !isShowSpinner" style="margin-left: 21px;" src="assets/images/green.png" width="30"
        height="30">
    <img *ngIf="isShowSpinner" src="assets/images/red.png" width="30" height="30">
    <p class="footer-one-text ping-status" *ngIf="isShowGreen && !isShowSpinner"> {{'Last pinged at'|translate}}
        {{lastPingedAt}} {{'on'|translate}} {{lastPingStatus}}</p>

    <div class="no-print" style="margin-left:25% ; width: 100%; display: flex;">
        <img *ngIf="!showTEList" src="assets/images/ajax-loader.gif" width="30" height="30" style="margin-top: 1%;
            padding-right: 0px;">
    </div>
    <div style="margin-left:25%; width: 100%; display: flex; font-family: Arial, Helvetica, sans-serif; font-size: 14px;font-weight: bold;">
        <p *ngIf="!showTEList">Fetching target engine status information</p>
    </div>
    <table class="table table-bordered tbl-root" *ngIf="showTEList">
        <thead></thead>
        <tbody>
            <ng-container *ngFor="let group of mergeStatusList">
                <tr style="font-weight: bold;">
                    <td style="background-color: lightgray;">{{group.header}}</td>
                </tr>
                <tr *ngFor="let root1 of group.rules">
                    <td>{{root1.id}} &nbsp;{{root1.language}}&nbsp;{{root1.country}}&nbsp;{{root1.date}}
                        <input class="admin-view-btn" type="button" name="add" value="{{'View'|translate}}"
                            (click)="showSpinner(root1.id)">
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <div *ngIf="isBackToTopShowBtn" (scroll)="onScroll($event)" class="back-to-top" style="display: block;"
        (click)="topFunction()">
    </div>